export const BILLING_PRODUCT = 'Premium subscription';



// WEBPACK FOOTER //
// ./app/components/reps/settings/constants.js